import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { LOGO_URL, CONTACT } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export const Footer = () => {
  const { lang, t, data } = useLang();
  const f = t.footer;
  return (
  <footer data-testid="site-footer" className="bg-ink text-cream/80 texture-grain">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-4">
          <img src={LOGO_URL} alt="SG Language Services LLC" className="h-14 w-14 rounded-full object-cover" />
          <span className="font-serif text-2xl text-cream font-semibold">SG Language Services LLC</span>
        </div>
        <p className="mt-6 text-sm leading-relaxed max-w-sm text-cream/60">{f.tagline}</p>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-periwinkle-light">{f.motto}</p>
      </div>

      <div className="md:col-span-3">
        <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-cream/40 mb-5">{f.services}</h3>
        <ul className="space-y-3">
          {data.SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-sm hover:text-periwinkle-light transition-colors duration-300">
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-cream/40 mb-5">{f.company}</h3>
        <ul className="space-y-3">
          <li><Link to="/about" className="text-sm hover:text-periwinkle-light transition-colors duration-300">{t.nav.about}</Link></li>
          <li><Link to="/portfolio" className="text-sm hover:text-periwinkle-light transition-colors duration-300">{t.nav.portfolio}</Link></li>
          <li><Link to="/blog" className="text-sm hover:text-periwinkle-light transition-colors duration-300">{t.nav.blog}</Link></li>
          <li><Link to="/faq" className="text-sm hover:text-periwinkle-light transition-colors duration-300">{t.nav.faq}</Link></li>
          <li><Link to="/contact" className="text-sm hover:text-periwinkle-light transition-colors duration-300">{t.footer.reach}</Link></li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-cream/40 mb-5">{f.reach}</h3>
        <ul className="space-y-3 text-sm text-cream/60">
          <li><a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-2 hover:text-periwinkle-light transition-colors duration-300"><Phone size={13} /> {CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-periwinkle-light transition-colors duration-300 break-all"><Mail size={13} /> {CONTACT.email}</a></li>
          <li className="flex items-center gap-2"><MapPin size={13} /> {f.address}</li>
          <li className="flex items-center gap-2"><Clock size={13} /> {CONTACT.hours[lang]}</li>
        </ul>
        <Link to="/contact" data-testid="footer-quote-link" className="inline-block mt-5 text-sm text-periwinkle-light link-underline">
          {f.quoteLink}
        </Link>
      </div>
    </div>
    <div className="border-t border-cream/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2">
        <p className="font-mono text-[11px] text-cream/40">© {new Date().getFullYear()} SG Language Services LLC. {f.rights}</p>
        <p className="font-mono text-[11px] text-cream/40">{f.cmi}</p>
      </div>
    </div>
  </footer>
  );
};
